// extracted by mini-css-extract-plugin
module.exports = {"container":"wishlist_container__14G65","title":"wishlist_title__3-I2H"};